import { GridApiPro } from '@mui/x-data-grid-pro'
import { AddOutlined, Refresh, TuneOutlined } from '@mui/icons-material'

import { Stack, SearchTextField, Button, IconButton } from '@collaborate-health/uikit'
import { useCurrentCorporation } from '@tabeeb/modules/admin/corporations/hooks'

import { Scope } from '../../enums'

import ScopeSelector from '../ScopeSelector'

export interface CertificatesGridToolbarProps {
  filtersActive?: boolean
  showScopeSelector?: boolean
  showAddButton?: boolean
  onOpenAddEditDialog: () => void
  onReload: () => void
  loading: boolean
  gridApiRef: React.MutableRefObject<GridApiPro>
  scope: Scope
  onScopeChange: (scope: Scope) => void
  searchText: string
  onSearchChange: (search: string) => void
}

const CertificatesGridToolbar: React.FC<CertificatesGridToolbarProps> = ({
  filtersActive = false,
  scope,
  onScopeChange,
  showScopeSelector = false,
  showAddButton = true,
  onOpenAddEditDialog,
  onReload,
  loading,
  gridApiRef,
  searchText,
  onSearchChange,
}) => {
  const { canManageCorporationCertificates } = useCurrentCorporation({ enabled: showScopeSelector })

  return (
    <Stack direction='row' spacing={2} mb={2} alignItems='center' justifyContent='space-between'>
      <SearchTextField
        size='small'
        value={searchText}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder='Search certificates...'
        InputProps={{
          endAdornment: (
            <IconButton
              size='small'
              color={filtersActive ? 'primary' : undefined}
              onClick={() => gridApiRef.current?.showFilterPanel()}
            >
              <TuneOutlined fontSize='small' />
            </IconButton>
          ),
        }}
      />
      <Stack direction='row' spacing={1}>
        <Button color='primary' size='small' startIcon={<Refresh />} disabled={loading} onClick={onReload}>
          Refresh
        </Button>
        {showScopeSelector && canManageCorporationCertificates && (
          <ScopeSelector value={scope} onChange={onScopeChange} />
        )}
        {showAddButton && (
          <Button
            color='primary'
            variant='contained'
            size='small'
            startIcon={<AddOutlined />}
            onClick={onOpenAddEditDialog}
          >
            Create certificate
          </Button>
        )}
      </Stack>
    </Stack>
  )
}

export default CertificatesGridToolbar

